export default {
  config: {
    header: {
      notes: 'Header in configuration pane in exciter expert analysis',
      message: 'Analysis configuration',
    },
    signal: {
      notes: 'Label when selecting signal in exciter expert analysis',
      message: 'Signal',
      placeholder: {
        notes: 'Placeholder when selecting signal in exciter expert analysis',
        message: 'Select signal...',
      },
    },
    settings: {
      notes: 'Header of settings in exciter expert analysis',
      message: 'Analysis settings',
    },
    sensor: {
      notes: 'Label for sensor field',
      message: 'Sensor',
      placeholder: {
        notes: 'Placeholder for sensor field in exciter expert analysis',
        message: 'Select sensor...',
      },
    },
    selectedTime: {
      notes: 'Label for time to run analysis at in exciter expert analysis',
      message: 'Sample start time',
      placeholder: {
        notes:
          'Placeholder for time to run analysis at in exciter expert analysis',
        message: 'Click in chart above to select time',
      },
      error: {
        notes:
          'Error message when no time is selected when performing analysis',
        message: 'No time selected',
      },
    },
    amplitude: {
      notes: 'Label for amplitude field in exciter expert analysis',
      message: 'Spectrum type',
      placeholder: {
        notes: 'Placeholder for amplitude field in exciter expert analysis',
        message: 'Select spectrum...',
      },
    },
    lowerCutoffFreq: {
      notes: 'Label for lower cutoff frequency in exciter expert analysis',
      message: 'Lower cutoff frequency',
    },
    upperCutoffFreq: {
      notes: 'Label for upper cutoff frequency in exciter expert analysis',
      message: 'Upper cutoff frequency',
      error: {
        greaterThan: {
          notes:
            'Error message when upper cutoff frequency is less than lower one',
          message: 'Needs to be greater than lower cutoff frequency',
        },
      },
    },
  },
  result: {
    header: {
      notes: 'Header of result accordion in exciter expert analysis',
      message: 'Result',
    },
    empty: {
      notes:
        'Empty text in result of exciter expert analysis before user has performed search',
      message: 'Enter settings and perform analysis to see result.',
    },
    frequencyRange: {
      header: {
        notes:
          'Header of frequency range signal section in exciter expert analysis',
        message: 'Frequency range signal',
      },
    },
    frequencyRangeSettings: {
      enabled: {
        notes: 'Switch label to enable / disable harmonics and sidebands',
        message: 'Frequency markers',
      },
      pattern: {
        notes:
          'Field label to select pattern to use for harmonics and sidebands',
        message: 'Frequency pattern',
      },
      harmonicsCount: {
        notes: 'Field label for number of harmonics',
        message: 'Number of harmonics',
      },
      sideBandCount: {
        notes: 'Field label for number of side bands',
        message: 'Number of side bands',
      },
    },
  },
  action: {
    analyze: {
      notes: 'Analyze action in exciter expert analysis',
      message: 'Analyze',
    },
  },
};
